import { render, staticRenderFns } from "./CriteriaValueInput.vue?vue&type=template&id=cb05c56c"
import script from "./CriteriaValueInput.vue?vue&type=script&lang=js"
export * from "./CriteriaValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports